import { Link } from 'react-router-dom';
import { calculatorRoutes, staticContentLinks } from '@/routes';

export function SiteFooter() {
  return (
    <footer className="border-t border-border/70 bg-background/85 backdrop-blur-xl">
      <div className="mx-auto grid w-full max-w-6xl gap-8 px-4 py-10 md:grid-cols-2 md:px-6 lg:grid-cols-5">
        <div>
          <h2 className="font-display text-lg font-semibold text-foreground">Fire-Calc</h2>
          <p className="mt-3 text-sm text-muted-foreground">
            Practical financial calculators for long-term planning, scenario analysis, and clearer money decisions.
          </p>
        </div>

        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.16em] text-muted-foreground">Calculators</p>
          <ul className="mt-3 space-y-2 text-sm">
            {calculatorRoutes.map((route) => (
              <li key={route.path}>
                <Link
                  to={route.path === '/' ? '/' : `${route.path}/`}
                  className="text-foreground/90 hover:text-foreground hover:underline"
                >
                  {route.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.16em] text-muted-foreground">About</p>
          <ul className="mt-3 space-y-2 text-sm">
            {staticContentLinks.about.map((link) => (
              <li key={link.href}>
                <Link to={link.href} className="text-foreground/90 hover:text-foreground hover:underline">
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.16em] text-muted-foreground">Resources</p>
          <ul className="mt-3 space-y-2 text-sm">
            {[...staticContentLinks.guides, ...staticContentLinks.resources].map((link) => (
              <li key={link.href}>
                <Link
                  to={link.href}
                  className={`text-foreground/90 hover:text-foreground hover:underline${link.href === '/guides/' ? ' font-semibold' : ''}`}
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.16em] text-muted-foreground">Legal</p>
          <ul className="mt-3 space-y-2 text-sm">
            {staticContentLinks.legal.map((link) => (
              <li key={link.href}>
                <Link to={link.href} className="text-foreground/90 hover:text-foreground hover:underline">
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </footer>
  );
}
